import {useEffect} from "react";

export const useVhProperty = () => {
  useEffect(() => {
    let width = window.innerWidth;

    const setVh = () => {
      const vh = window.innerHeight;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVh(); // Ініціалізуємо при першому рендері

    const handleResize = () => {
      if (width !== window.innerWidth) {
        setVh();
        width = window.innerWidth;
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
};